<template>
<div id="app_container">
    <!-- content -->
    <v-content>
        <router-view :key="$route.fullPath" />
    </v-content>
    <!-- ./ content -->
</div>
</template>

<script>
export default {
    components: {},

    name: 'AppContainer',

    data() {
        return {

        }
    },

    watch: {


    },

    mounted() {

    },

    methods: {




    },

}
</script>
<style lang="stylus">

</style>
